import React from 'react';
import { useLocation } from 'react-router-dom';

const OptInConfirmation = () => {
    const location = useLocation();
    const trainerName = location.state?.trainerName || 'your trainer';

    return (
        <div className="reminder-container fogged-card">
            <h2>Thank You!</h2>
            <p>You’ll now receive SMS reminders from {trainerName}.</p>
            <p>Please head back to 
                <a href="/tools/reminders/dashboard">the SweatText tool page</a> 
                if you would like to see a dashboard of what reminders are scheduled.
                You may be prompted for re-login using your Google account.</p>
        </div>
    );
};

export default OptInConfirmation;